import { Grid, Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const LoadingProduct = ({ show }) => {
    return show ? (
        <>
            {Array.from(new Array(20)).map(() => (
                <Grid item xl={2} lg={2.2} md={2.4} sm={4} xs={6} align="center">
                    <Box width={150} height={250}>
                        <Skeleton variant="rectangular" width={150} height={150} />
                        <Skeleton />
                        <Skeleton width="60%" />
                    </Box>
                </Grid>
            ))}
        </>
    ) : null;
};

export default LoadingProduct;
